import axios from "axios";
import {getAppLang, getUserToken} from "../../../../utils";
import {
    SALES_DEMO_CHECK,
    SALES_DEMO_START,
    SALES_DEMO_STATUS,
    SALES_DEMO_LIST,
    SALES_DEMO_SEARCH,
} from "../../../../constants/api.constants";
import {salesDemoConstants} from "../../../../constants/General/salesDemo.constants";

const getHeaders = () => ({
    'Content-Type': 'application/json',
    'authToken': getUserToken(),
    'language': getAppLang(),
});

// Menu yalnizca can_start true ise gorunur. Izin listesi api'de; on yuzde e-posta listesi tutulmuyor.
export function salesDemoCheck() {
    return dispatch => {
        dispatch({
            type: 'SALES_DEMO_CHECK',
            payload: axios.get(SALES_DEMO_CHECK, {headers: getHeaders()})
                .then(response => response.data)
        })
    }
}

// Kullanicinin son 20 kosusu, en yenisi basta.
export function salesDemoList() {
    return dispatch => {
        dispatch({
            type: 'SALES_DEMO_LIST',
            payload: axios.get(SALES_DEMO_LIST, {headers: getHeaders()})
                .then(response => response.data)
        })
    }
}

// Otel adiyla arama (q en az 3 karakter, en fazla 10 sonuc). Gec gelen eski cevap
// yenisini ezmesin diye sorgu meta ile tasinir; reducer yalniz son sorguyu kabul eder.
export function salesDemoSearch(query) {
    return dispatch => {
        dispatch({
            type: 'SALES_DEMO_SEARCH',
            meta: {query},
            payload: axios.get(SALES_DEMO_SEARCH, {headers: getHeaders(), params: {q: query}})
                .then(response => response.data)
        })
    }
}

export function clearSalesDemoSearch() {
    return dispatch => {
        dispatch({
            type: salesDemoConstants.SALES_DEMO_SEARCH_CLEAR,
        })
    }
}

// Yeni kosu: {booking_hotel_id | booking_url, idempotency_key, domain?}
// Yeniden deneme: {run_id, retry: true} — yeni anahtar gonderilmez, yoksa ikinci bir otel acilir.
export function salesDemoStart(params) {
    const body = {
        params: params
    };

    return dispatch => {
        dispatch({
            type: 'SALES_DEMO_START',
            payload: axios.post(SALES_DEMO_START, body, {headers: getHeaders()})
                .then(response => response.data)
        })
    }
}

export function salesDemoStatus(runId) {
    const body = {
        params: {
            run_id: runId
        }
    };

    return dispatch => {
        dispatch({
            type: 'SALES_DEMO_STATUS',
            payload: axios.post(SALES_DEMO_STATUS, body, {headers: getHeaders()})
                .then(response => response.data)
        })
    }
}

export function clearSalesDemo() {
    return dispatch => {
        dispatch({
            type: salesDemoConstants.SALES_DEMO_CLEAR,
        })
    }
}
